import React, { useContext, useEffect, useRef, useState } from "react";
import { professionalAction } from "../../_actions";
import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import { connect } from "react-redux";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {
  BarChartOutlined,
  CloseCircleFilled,
  SearchOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { LanguageContext } from "../../context/LanguageContext";
import { notificationAction } from "../../_actions/notifications.actions";
import { TablePreventiveNotification } from "../Reports/Tables/preventiveNotificationtable";
import moment from "moment";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx-js-style";
import _ from "lodash";

const PreventiveNotification = (props) => {
  const { Option } = Select;
  console.log("props", props);

  const [download, setDownload] = useState("excel");
  const [city, setCity] = useState(props?.user?.cityId);
  const [data, setData] = useState([]);
  const [criminalViewModel, setCriminalViewModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const { language, setLanguage, t } = useContext(LanguageContext);
  const [show, setShow] = useState("list");
  const [countData, setCountData] = useState([]);
  const [count, setCount] = useState(0);
  const [year, setYear] = useState([]);
  const [selectedHeadings, setSelectedHeadings] = useState([]);
  const [preventiveAction, setPreventiveAction] = useState([]);

  const [countbtn,setCountbtn] = useState("preventive");
  const handleCountbtn = (btn) => {
    setCountbtn(btn);
    if (btn === "preventive") {
      PreventiveActionNotificationCount();
    } else {
      DistrictWiseNotificationCount();
    }
  };

  const getPreventiveInfo = () => {
    professionalAction.getPreventiveAction().then((res) => {
      res &&
        res.text().then((preventiveList) => {
          const data = [];
          preventiveList &&
            JSON.parse(preventiveList).data.forEach((item) => {
              data.push(item);
            });
          setPreventiveAction(data);
        });
    });
  };
  useEffect(() => {
    getPreventiveInfo();
  }, []);

  const clearFilters = () => {
    setSerachText("");
    setYear([]);
    setSelectedHeadings([]);
    setIsSearch(false);

    setTimeout(() => {
      preventiveNotification("", [], []); // send actual cleared values
    }, 200); // no need for 1200ms delay
  };

  const preventiveNotification = (searchParam, yearParam, preventive) => {
    if (props.user.role === "4") {
      let obj = {
        city: props.user.cityId,
        search: searchParam,
        year: yearParam,
        preventive_action: preventive,
      };

      notificationAction
        .cityWisePreventiveActionNotification(obj)
        .then((res) => {
          res &&
            res.json().then((criminalList) => {
              console.log("preventive notification", criminalList);
              setData(criminalList.data);
            });
        });
    } else {
      let obj = {
        district:
          props.user.role === "2"
            ? [props.user.districtId]
            : props.user.map_districtId,
        search: searchParam,
        year: yearParam,
        preventive_action: preventive,
      };
      notificationAction
        .distinctPreventiveActionNotification(obj)
        .then((res) => {
          res &&
            res.json().then((criminalList) => {
              console.log("preventive notification", criminalList);
              setData(criminalList.data);
              if (searchParam || (yearParam && yearParam.length > 0)) {
                setIsSearch(true);
              }
            });
        });
    }
  };

  const PreventiveActionNotificationCount = () => {
    if (props.user.role === "4") {
      let obj = {
        city: props.user.cityId,
      };
      notificationAction
        .cityWisePreventiveActionNotificationCount(obj)
        .then((res) => {
          res &&
            res.json().then((criminalList) => {
              console.log("preventive notification", criminalList);
              setCountData(criminalList.data);
              const totalCount = criminalList.data.reduce(
                (sum, item) => sum + (item.count || 0),
                0,
              );

              setCount(totalCount);
            });
        });
    } else {
      let obj = {
        district:
          props.user.role === "2"
            ? [props.user.districtId]
            : props.user.map_districtId,
      };
      notificationAction
        .distinctPreventiveActionNotificationCount(obj)
        .then((res) => {
          res &&
            res.json().then((criminalList) => {
              console.log("preventive notification", criminalList);
              setCountData(criminalList.data);
              const totalCount = criminalList.data.reduce(
                (sum, item) => sum + (item.count || 0),
                0,
              );

              setCount(totalCount);
            });
        });
    }
  };
  const onViewAccusedForm = (data) => {
    if (data) {
      props.dispatch(professionalAction.getCriminalsViewsByIdView(data));
      showCriminalViewModel();
    }
  };

  const showCriminalViewModel = () => {
    setCriminalViewModel(true);
  };

  const closeCriminalViewModel = () => {
    setCriminalViewModel(false);
  };
  const getCityName = (id) => {
    const { pc_cities } = props && props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  const [form] = Form.useForm();
  const [formDownload] = Form.useForm();

  const download_csv = () => {
    const ReportTitle = "Preventive_Notification_Report";
    const title = "प्रतिबंधक_कारवाई";

    // Ensure it's an array
    const arrData = Array.isArray(data) ? data : [];

    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;

    let list = arrData.map((item, index) => {
      // Ensure kk_info is an array
      const kkInfoArray = Array.isArray(item.kk_info) ? item.kk_info : [];
      if (kkInfoArray.length === 0) return null;

      // Group kalam → unique rules
      const grouped = kkInfoArray.reduce((acc, kk) => {
        const name = kk?.rulesName || "-";
        const kalma = kk?.kalam || "-";

        if (!acc[name]) {
          acc[name] = [kalma];
        } else if (!acc[name].includes(kalma)) {
          acc[name].push(kalma);
        }
        return acc;
      }, {});

      const groupedStr = Object.entries(grouped)
        .map(([rule, kalams]) => `${rule}: ${kalams.join(", ")}`)
        .join("; ");

      const formatDate = (val) =>
        moment(val).isValid() ? moment(val).format("DD/MM/YYYY") : "-";

      return {
        "अ.क्र.": index + 1,
        "आरोपीचे नाव": item.basic_name || "-",
        पत्ता: item.address || "-",
        "कारवाई करणारे पो. स्टे ": item.action_taken_police_station,
        "चालू प्र. कारवाई ": item.preventive_action_name || "-",
        पासून: formatDate(item.date_from),
        पर्यन्त: formatDate(item.date_to),
        "गुन्ह्याचे पो. स्टे": item.guna_districtName || "-",
        "दरम्यान दाखल गुन्हा": formatDate(item.gunha_dateTime),
        "गु.र.नंबर": item.registernumber ? item.registernumber : "",
        "कायदा कलम": groupedStr,
      };
    });

    // ✅ Remove null/undefined entries
    const exportData = (list || []).filter(Boolean);

    // ✅ Prevent crash if no data
    if (!exportData.length) {
      console.error("No data available to export.");
      return;
    }

    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(exportData, { origin: "A4" });

    // Column widths
    const columnWidths = Object.keys(exportData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...exportData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));
    ws["!cols"] = columnWidths;

    // Styles
    const headerStyle = {
      font: { bold: true, sz: 12 },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };
    const cellStyle = {
      font: { sz: 12 },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    // Apply header styles
    Object.keys(exportData[0]).forEach((_, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: index });
      if (!ws[cellRef]) ws[cellRef] = {};
      ws[cellRef].s = headerStyle;
    });

    // Apply cell styles
    exportData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (!ws[cellRef]) ws[cellRef] = {};
        ws[cellRef].s = cellStyle;
      });
    });

    // Add report headers
    ws["A1"] = {
      v: getCityName(props.user.cityId || ""),
      t: "s",
      s: headerStyle,
    };
    ws["A2"] = { v: ReportTitle, t: "s", s: headerStyle };

    // Footer
    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;
    const footerRowIndex = exportData.length + 6;
    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { bold: true, sz: 12, color: { rgb: "000000" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    // Merge headers + footer across all columns
    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
    ];
    ws["!merges"] = mergeRanges;

    // Row heights
    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    // Finalize workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  const downloadReport = (download) => {
    console.log("test", download);
    if (download == "excel") {
      download_csv();
    }
  };
  let columns = {
    arophi_new_list: [
      { title: "अ.क्र.", dataIndex: "index", key: "index", width: 50 },
      { title: "आरोपीचे नाव", dataIndex: "name", key: "name" },
      { title: "वय", dataIndex: "age", key: "age" },
      { title: "आरोपीचे पोलिस ठाणे", dataIndex: "age", key: "age" },
      {
        title: "एकुण गुन्हे",
        dataIndex: "gunhaCount",
        key: "gunhaCount",
      },
      {
        title: "सद्यस्थिती",
        dataIndex: "currentcondition",
        key: "currentcondition",
      },
      {
        title: "फोटो",
        dataIndex: "photoPresent",
        key: "photoPresent",
      },
    ],
  };

  let columnsToShow = columns?.arophi_new_list.map((col) => ({
    ...col,
    title: <span style={{ fontSize: "18px" }}>{col.title}</span>,
  }));

  const DistrictWiseNotificationCount = () => {
    let obj={
      city: props.user.cityId,
    }
    notificationAction.districtWiseCountPreventiveNotification(obj).then((res) => {
      res &&
      res.json().then((criminalList) => {
        console.log("preventive notification", criminalList);
        setCountData(criminalList.data);
        const totalCount = criminalList.data.reduce(
          (sum, item) => sum + (item.count || 0),
          0,
        );
        setCount(totalCount);
      });
    });
  };
  //
  const [searchText, setSerachText] = useState("");
  const [isSearch, setIsSearch] = useState(false);
  useEffect(() => {
    if (show == "list") {
      preventiveNotification();
    }
    if (show == "count") {
      if (countbtn === "preventive") {
        PreventiveActionNotificationCount();
      } else {
        DistrictWiseNotificationCount();
      }
    }
  }, [show]);

  const currentYear = new Date().getFullYear();

  const yearOptions = [];
  for (let y = 2010; y <= currentYear; y++) {
    yearOptions.push(y);
  }
  const handleYear = (e) => {
    setYear(e);
  };

  const handlePrventive = (e) => {
    setSelectedHeadings(e);
  };
  return (
    <>
      <div
        className="filter-row"
        style={{
          padding: "16px 20px",
          background: "#fff",
          borderRadius: "8px",
          border: "1px solid #f0f0f0",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          marginBottom: "20px",
          overflowX: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "nowrap", // ✅ prevent items from wrapping
            gap: "16px",
            alignItems: "center",
          }}
        >
          {/* Left: Search + Year + Find + Clear */}

          {show === "list" && (
          <>
         
            <div
              style={{
                display: "flex",
                flexWrap: "nowrap", // keep these inline too
                gap: "12px",
                alignItems: "center",
                flex: "1 1 auto",
                minWidth: "280px",
              }}
            >
              <Input
                placeholder="Search..."
                value={searchText}
                onChange={(e) => setSerachText(e.target.value)}
                disabled={data.length === 0}
                prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                style={{ flex: "1", borderRadius: "6px", minWidth: "200px" }}
                allowClear
              />

              <Select
                placeholder={t("crimes_year")}
                value={year}
                onChange={(val) => handleYear(val.map(Number))}
                mode="multiple"
                allowClear
                style={{ minWidth: 120, maxWidth: 300 }}
                size="middle"
                showSearch
                filterOption={(input, option) =>
                  option.children
                    .toString()
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                maxTagCount={1}
              >
                {yearOptions.map((y) => (
                  <Option key={y} value={y}>
                    {y}
                  </Option>
                ))}
              </Select>
              <div
                style={{
                  padding: "16px",
                  background: "#fff",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      style={{
                        flex: "1 1 300px",
                        minWidth: "250px",
                      }}
                    >
                      <Select
                        optionFilterProp="children"
                        placeholder="Please select प्रतिबंधक कारवाही"
                        mode="multiple"
                        value={selectedHeadings}
                        disabled={data == 0}
                        onChange={(val) => handlePrventive(val)}
                        style={{ width: "100%" }}
                        dropdownStyle={{ minWidth: "250px" }}
                        maxTagCount="responsive"
                        maxTagTextLength={20}
                      >
                        {preventiveAction.length &&
                          preventiveAction.map((res, index) => (
                            <Option key={index} value={res.id}>
                              {res.name}
                            </Option>
                          ))}
                      </Select>
                    </div>
                  </div>
                </div>
              </div>

              {(searchText ||
                year.length > 0 ||
                selectedHeadings.length > 0) && (
                <Button
                  type="primary"
                  className="modern-button modern-button-success"
                  onClick={() => {
                    preventiveNotification(searchText, year, selectedHeadings);
                    setIsSearch(true);
                  }}
                >
                  {t("find")}
                </Button>
              )}

              {isSearch && (
                <Button
                  className="modern-button modern-button-danger"
                  onClick={clearFilters}
                >
                  {t("clear")}
                </Button>
              )}
            </div>
            {show === "list" && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "nowrap",
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#262626",
                    whiteSpace: "nowrap",
                  }}
                >
                  {t("download")}:
                </span>
                <Form form={formDownload}>
                  <Form.Item
                    name="condition"
                    rules={[
                      { required: true, message: "Please select a value" },
                    ]}
                    style={{ marginBottom: 0 }}
                  >
                    <Select
                      placeholder={t("please_select_an_option")}
                      defaultValue={download}
                      onChange={setDownload}
                      value={download}
                      style={{ width: "120px" }}
                      size="middle"
                      disabled={data.length === 0}
                    >
                      <Option key="excel" value="excel">
                        {t("excel")}
                      </Option>
                    </Select>
                  </Form.Item>
                </Form>
                {download && (
                  <Button
                    type="primary"
                    className="modern-button modern-button-success"
                    onClick={() => downloadReport(download)}
                    disabled={data.length === 0}
                  >
                    {t("download")}
                  </Button>
                )}
              </div>
            )}
          </>
          )}

          <div style={{ flexShrink: 0 }}>
            <Link to="/">
              <Button
                type="primary"
                className="modern-button modern-button-close"
              >
                Home
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          width: "100%",
          padding: "16px 0",
        }}
      >
        {/* View Type Selection */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "12px",
            alignItems: "center",
            padding: "12px",
            background: "#f5f5f5",
            borderRadius: "8px",
            boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "8px",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <Button
              type={show === "count" ? "primary" : "default"}
              icon={<BarChartOutlined />}
              style={{
                minWidth: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
              onClick={() => {
                setShow("count");
              }}
            >
              {t("statistics")}
            </Button>

            <Button
              type={show === "list" ? "primary" : "default"}
              icon={<UnorderedListOutlined />}
              style={{
                minWidth: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
              onClick={() => {
                setShow("list");
              }}
            >
              {t("list")}
            </Button>

            <div
              style={{
                padding: "4px 12px",
                background: "#fff",
                borderRadius: "4px",
                border: "1px solid #d9d9d9",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <span style={{ color: "#666" }}>एकुण:</span>
              <span style={{ fontWeight: "bold" }}>
                {show === "list" ? data.length : count}
              </span>
            </div>
          </div>
         
        </div>
        {show === "count" && (
        <div
        style={{
          display: "flex",
          gap: "12px",
          alignItems: "right",
          justifyContent: "right",
          marginRight: "10px",
        }}
        >
        <Button type="default" 
        className={countbtn === "preventive" && "active-button-aaropi" }
        
        onClick={() => handleCountbtn("preventive")}>
            प्रतिबंधक कारवाई निहाय
          </Button>
          {props.user.role === "4" && (
          <Button type="default" className={countbtn === "district" && "active-button-aaropi"} onClick={() => handleCountbtn("district")}>
            पोलिस स्टेशन निहाय
          </Button>
          )}
        </div>
        )}
        {/* Table Section */}
        <div
          style={{
            width: "100%",
            overflowX: "auto",
            background: "#fff",
            borderRadius: "8px",
            border: "1px solid #f0f0f0",
            boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
          }}
        >
          <TablePreventiveNotification
            data={show === "list" ? data : countData}
            key={data}
            allTotal={count}
            total={count}
            onViewAccusedForm={onViewAccusedForm}
            loading={loading}
            list={show}
            preventiveNotification={preventiveNotification}
            preventive={preventiveAction}
            countbtn={countbtn}
          />
        </div>
      </div>

      <Modal
        title="आरोपी प्रोफाइल"
        top
        visible={criminalViewModel}
        onOk={closeCriminalViewModel}
        onCancel={closeCriminalViewModel}
        width={95 + "%"}
      >
        <ViewFormModel dataStates={props?.professionals}></ViewFormModel>
      </Modal>
    </>
  );
};

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedWanted = connect(mapStateToProps)(PreventiveNotification);
export { connectedWanted as PreventiveNotificationList };
